<template>
  <div v-if="technologycategory !== null">
    <!-- 技術分類 -->
    <div class="block mb-5">
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="technologycategory.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Subtitle -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>副標</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="technologycategory.subtitle"
            placeholder="請輸入副標"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- BU -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5">
          <h4>BU</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px my-n2">
            <v-autocomplete
              v-model="technologycategory.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="technologycategory.status"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="technologycategory.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Slug -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="technologycategory.slug"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 封面圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">封面圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於技術類別列表Overview頁面 <br />
            建議尺寸：430px * 430px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="technologycategory.cover_image"
            dir="TechnologyCategory"></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
  },
  data: () => ({
    tab: '',
    status: true,
    bu: [],
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState(['buTabs']),
    ...mapState('technologycategory', ['technologycategory']),
  },
};
</script>

<style></style>
